var Log = {
	error: function(msg, where) {
		alert(msg + " (" + where + ")");
	},
	
	debug: function(msg) {
		console.log(msg);
	}
}